import { MLanguage } from 'vue-multilanguage'
const english = new MLanguage('english').create({
  lang_tag: 'EN',
  contacts: {
    title: 'Contacts',
    company_info: 'Sede Legale: Via Mac Mahon 9 - 20155 Milano (MI)<br>Sede Operativa: Viale De Gasperi 77 - 20017 Mazzo di Rho (MI)<br>P.IVA: 11766720152Tel. +39 02.99766242 - Fax +39 02.99766243 info@trackingonline.it',
    fill_title: 'Fill in the form to be contacted',
    company: 'Company',
    firstname: 'First name',
    lastname: 'Last name',
    email: 'E-mail address',
    telephone: 'Telephone',
    city: 'City / town',
    message: 'Message',
    how: 'How have you found us?',
    how_options: [
      { text: 'search engine', value: 'motore di ricerca' },
      { text: 'ad banners', value: 'banner' },
      { text: 'link on another website', value: 'link su altro sito' },
      { text: 'by chance', value: 'casualmente' },
      { text: '(other reason)', value: '(altro)' }
    ],
    how_answer: 'Specify',
    privacy_info: 'Accordingly to EU regulamentation regarding privacy ("GDPR"), we will use your personal data for the sole purpose of marketing',
    privacy_agree: 'I agree',
    submit: 'Submit'
  },
  contents: {
    title: 'Downloadable contents',
    sub_title: 'Here you can find several media, such as videos, images, brochures amd a brief guide of how OpenTracking® works'
  },
  credits: {
    title: 'A few of our references'
  },
  features: {
    title: 'Features',
    subtitle: 'Accesso web multiutente',
    card_1: {
      title: 'Per i corrispondenti o TP',
      text: [
        'Visione delle spedizioni affidate.',
        "Possibilità di inserire l'esito dello stato della spedizione con la lista delle causali.",
        'Upload del file degli esiti tramite web, email, ftp.',
        'Invio diretto degli esiti tramite SOAP o JSON.'
      ]
    },
    card_2: {
      title: 'Per i destinatari',
      text: [
        'Consultazione dello stato della spedizione ricercata per riferimento mittente o progressivo.',
        'Visualizzazione dei dettagli con i vari stati di avanzamento della spedizione.',
        'Segnalazione dell’anomalia con l’invio della foto del pacco.',
        'Richiesta bolla firmata.'
      ]
    },
    card_3: {
      title: 'Per le mandanti',
      text: [
        'Visualizzazione delle proprie spedizioni con i dettagli e lo stato aggiornati in tempo reale.',
        'Possibilità di dare disposizione degli avvisi di giacenza.',
        "Possibilità di ricevere notifiche dell'andamento delle proprie spedizioni."
      ]
    },
    card_4: {
      title: 'Web interattivo',
      text: [
        'Tracking-Online® si prefigge di leggere i dati direttamente dal sistema centrale e di aggiornarli a seconda delle informazioni ricevute dagli attori della spedizione via scambio file, interazione via web o E-mail dinamica.'
      ]
    },
    card_5: {
      title: 'E-mail dinamica',
      text: [
        "Tracking-Online® oltre ad assicurare l'interscambio dati fra più Aziende, integra lo strumento e-mail per coordinare il ciclo attivo di disposizioni su notifica di un evento.",
        'È possibile configurare un flusso/percorso di disposizione e autorizzazione distinto per ogni evento e coinvolgere direttamente il titolare della disposizione. Es. un avviso di giacenza, catalogato automaticamente, può essere inviato direttamente al Mittente/Mandante di una spedizione con la richiesta della disposizione (riconsegnare, reso al mittente, note etc.) che verrà inviata al vettore/trasportatore.'
      ]
    },
    card_6: {
      title: 'Interscambio files',
      text: [
        'Tracking-Online® accetta tutti i tipi di comunicazione Internet (Web, E-mail, FTP) con flussi automatici e normalizzati operando le opportune trascodifiche. Quindi non è necessario modificare alcun database o procedura di generazione ed invio files.',
        'a) Comunicazione degli esiti delle spedizioni da parte dei corrispondenti con verifica immediata e conferma d’inserimento.',
        'b) Lettura dei borderò da parte di corrispondenti e conferma dell’avvenuta acquisizione.',
        'c) Consultazione da parte della mandante dello stato delle spedizioni con i relativi dettagli.'
      ]
    },
    card_7: {
      title: 'Interazione con il sistema centrale e controllo qualità',
      text: [
        'Tracking-Online® è la piattaforma ideale per aggiungere al proprio sistema centrale non solo il colloquio con elementi periferici ma aggiungere funzionalità assenti.',
        "Internet è lo strumento ideale per creare nuove procedure automatizzate che interagiscono con il ciclo attivo. Si possono aggiungere funzioni che incidono sull'operatività o di monitor della stessa con statistiche approfondite per il controllo operativo e qualitativo dell'Azienda nei confronti dei suoi Clienti e nei confronti dei fornitori di servizi complementari logistici, nonchè fatturazione o autofatturazione."
      ]
    },
    card_8: {
      title: 'Gestione delle permission',
      text: [
        'Possibilità di gestire granularmente i permessi degli utenti.',
        'Per fare ciò abbiamo implementato il sistema dei profili che non sono suddivisi in una gerarchia piramidale, bensì libera.',
        'Ad esempio un profilo potrebbe gestire i resi, ma non poter modificare gli utenti, o aggiungere causali, ma non aver potere sulla gestione delle festività'
      ]
    },
    card_9: {
      title: 'Gestione delle causali',
      text: [
        'Totale libertà di creare causali di eventi da monitorare e gestione delle permission di lettura e scrittura di ogni singolo componente di una pagina.',
        'Esse possono essere categorizzate e considerate definitive o non definitive',
        'Se al sistema perviene un evento con causale definitiva non importerà eventi successivi, a meno che questo non venga annullato, in tal caso la spedizione sarà nuovamente in corso.'
      ]
    },
    card_10: {
      title: 'Gestione dei KPI',
      text: [
        'Possibilità di impostare le regole dei KPI e controllare il rispetto di essi tramite il Dashboard',
        'Modulo delle statistiche con le percentuali di esito aggiornate in tempo reale per mantenere al top la qualità del servizio.',
        'Notifiche personalizzate per intervenire su criticità.'
      ]
    },
    card_11: {
      title: 'Statistiche',
      text: [
        'Gestione delle statistiche altamente personalizzata:',
        'Dashboard customizzabile con i grafici della BI (Business Intelligence)',
        'Possibilità di scaricare il dashboard selezionato in pdf e di riceverlo in automatico tramite e-mail.'
      ]
    },
    card_12: {
      title: 'Estrazioni automatiche pianificabili',
      text: [
        "Gestione delle estrazioni ripetitive e della loro schedulazione per l'invio in automatico via e-mail ai destinatari configurati."
      ]
    },
    card_13: {
      title: 'Connessione alla piattaforma logistica www.OpenTracking.it',
      text: [
        "Tracking-Online® interagisce con la piattaforma logistica OpenTracking® nella quale vengono pubblicate le spedizioni e tutti gli eventi che ogni protagonista della supply chain genera ed interscambia fino ad arrivare all'esito finale."
      ]
    },
    card_14: {
      title: 'APP OpenTracking',
      text: [
        '',
        ''
      ]
    }
  },
  hello: {
    title: '',
    first_p: 'Don\'t lose cotrol over your deliveries.<br>Save time and money in all your communications',
    description: "Tracking-Online ® è un'applicazione web multi-utente/multi-profilo sviluppata da Netland Srl che informa, gestisce e coordina le attività delle società di Logistica e Trasporti che coinvolgono i loro Clienti (mittenti/mandanti delle spedizioni), la loro attività (sia di logistica che di trasporto) e i Destinatari Finali delle Spedizioni. La gestione di tali attività è possibile grazie all'ausilio delle forme più comuni di comunicazione elettronica come e-Mail, web, ftp, oppure comunicazione diretta tra i sistemi delle Aziende, sia in modo automatico che non (a discrezione del titolare dell'applicazione).<br><br>Tracking-Online® è un prodotto concesso in licenza d'uso che comprende il software e le personalizzazioni necessarie ed è in grado di gestire e coordinare tutte le comunicazioni con i Clienti mandanti e le Società fornitrici di servizi complementari (logistica, trasporti e distribuzione)."
  },
  help: {

  },
  menu: {
    title: 'Tracking-Online<sup>®</sup>',
    subtitle: 'Version 2.0 is now available',
    contacts: 'Contacts',
    contents: 'Contents',
    credits: 'Credits',
    features: 'Features',
    home: 'Home',
    opentracking: 'OpenTracking®',
    tracking: 'Tracking-Online',
    presentation: 'Presentation'
  },
  opentracking: {
    title: 'OpenTracking<sup>®</sup>',
    description: [
      'By using OpenTracking<sup>®</sup> platform, this APP allows a company to hand over orders to drivers outside the company.',
      'Drivers can hand deliveries given by several companies using one single smartphone and the result along with a P.O.D. (Proof of Delivery) and pics will be sent back to the top giving each and every actor of the delivery what is due to them.'
    ],
    read_more: 'Read more',
    card_1: {
      title: 'Platform',
      text: []
    },
    card_2: {
      title: 'APP',
      text: []
    },
    card_3: {
      title: 'Plug In',
      text: []
    },
    card_4: {
      title: 'QR Code',
      text: []
    },
    card_5: {
      title: 'Proof of Delivery (POD)',
      text: []
    },
    card_6: {
      title: 'Foto riserva',
      text: []
    },
    paragraph_1: {
      title: 'Piattaforma OpenTracking<sup>®</sup>',
      text: []
    },
    paragraph_2: {
      title: 'APP OpenTracking',
      text: []
    },
    paragraph_3: {
      title: 'Plug In',
      text: []
    },
    paragraph_4: {
      title: 'QR Code',
      text: []
    },
    paragraph_5: {
      title: 'Proof of Delivery (POD)',
      text: []
    },
    paragraph_6: {
      title: 'Foto riserva',
      text: []
    }
  },
  tracking: {
    title: 'Tracking-Online®',
    list_title: 'Tracking-Online® comes with the following features:',
    list_item_1: 'Management of users and respective profiles',
    list_item_2: 'Powerful search functionality',
    list_item_3: 'Delivery details',
    list_item_4: 'Current/past held ware showcase and management',
    list_item_5: 'Possibility to give instruction on held ware',
    list_item_6: 'Management of orders with a mandatory delivery date',
    list_item_7: 'Interactive and automatic compilation of discharge reports including anomalies',
    list_item_8: 'Invio e Ricezione compiti e esiti secondo le specifiche accordate per ogni utente',
    list_item_9: 'a Barcode scanner to send a shipment outcome',
    list_item_10: 'Customizations for each and every user',
    list_item_11: 'Quality statistics',
    submit: 'Ask for a demo'
  },
  legal: {
    text: `L'utilizzo non autorizzato del presente messaggio è vietato e potrebbe costituire reato.<br>
Se il presente messaggio non e' a Lei indirizzato, Le saremmo grati se, via e-mail, ne comunicasse l'errata ricezione.<br>
Il contenuto del presente messaggio non deve essere considerato come trasmesso o autorizzato da NETLand.<br>
NETLand non si assume alcuna responsabilità per eventuali intercettazioni, modifiche o danneggiamenti del presente messaggio e-mail.<br><br>
The information contained in this message is intended only for use of the individual(s) named above and may contain confidential, proprietary or legally privileged information.<br>
No confidentiality or privilege is waived or lost by any mistransmission. if you are not the intended recipient of this message you are hereby notified that you must not use, disseminate, copy it in any form or take any action in reliance of it. If you have received this message in error please delete it and any copies of it and notify the sender immediately.`
  }
})
export { english }



// WEBPACK FOOTER //
// ./src/languages/english.js